import { Box } from "@mui/material";

export const ImageViewer = ({
  alt = "Zone a inspecté",
  source,
  caption = "Image satellitaire de la zone",
}) => {
  return (
    <figure>
      <Box sx={{ borderRadius: 3, overflow: "hidden", textAlign: "center" }}>
        <img src={source} alt={alt} width="100%" />
        <figcaption>{caption}</figcaption>
      </Box>
    </figure>
  );
};
